<template>
  <div>
    
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div class="main-container">
      <div class="row">
        <div class="col-4">
          <txt label="Policy Number" name="policy_number" v-model="model.policy_number" />
        </div>
        <div class="col-4">
          <txt label="Policy Holder Name" name="policy_holder_name" v-model="model.policy_holder_name" />
        </div>
        <div class="col-4">
          <txt label="Sum Assured" name="sum_assured" v-model="model.sum_assured" />
        </div>
        <!-- <div class="col-4">
          <tl-select label="Relationship" 
          :options="['Aunt','Brother','Daughter','Father','Grandfather','Grandmother',
              'Guardian','Husband','Mother','Sister','Son','Uncle','Wife']"
          :value="model.relationship"
          @change="(val)=>model.relationship=val"/>
        </div> -->
      </div>
      <div class="row margin-t-m">
        
        <div class="col-4">
          <div class="label">
            <span class="input-label">Policy Date</span>
            <date-picker
              name="policy_date"
              :value="model.policy_date"
              @datevalue="(val)=> model.policy_date = val"
            />
          </div>
        </div>
        <div class="col-4">
          <div class="label">
            <span class="input-label">Date Of Payment</span>
            <date-picker
              name="date_payment"
              :value="model.date_payment"
              @datevalue="(val)=> model.date_payment = val"
            />
          </div>
        </div>  
        <div class="col-4">
          <txt label="Premium Amount" type="number" name="premium_amount" v-model="model.premium_amount" />
        </div>
        <div class="col-12 margin-t-m">
          <div
            class="upload-heading"
          >Upload the policy</div>
          <upload @change="(val)=>docUrl=val.data.location" />

        </div>
          <div class="col-3">
          <img :src="model.docUrl" />
        </div>
        <div class="col-12 margin-t-m">
          <btn text="Add Policy" type="secondary" @click="addMore()" />
        </div>
      </div>

      <div class="margin-t-l">
        <data-table
          :columns="tableColumns"
          :tableData="policyList"
          :showinrow="true"
          :showhistory="false"
          :showedit="false"
          @delete="deleteItem($event)"
        >
          <template v-slot:rowcontent="slotprops">
            <div>
              <p v-if="slotprops.value.column.key == 'srNo'">{{slotprops.value.index+1}}</p>
              <p
                v-if="slotprops.value.column.key == 'policy_number'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key == 'policy_date'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key == 'policy_holder_name'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key == 'sum_assured'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key == 'date_payment'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key == 'premium_amount'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key == 'proofs'"
              >{{slotprops.value.record[slotprops.value.column.key].length}} attacment</p>
            </div>
          </template>
        </data-table>
      </div>
  
    </div>
    <pop-up-message
      v-if="showSuccessMsg"
      :message="`${$route.query.page} added succesfully.`"
      btnText="Back"
      @back="back"
    ></pop-up-message>
      <footer>
        <popup-bottom-container>
          <template slot="end">
            <btn-grp class="form-button">
              <btn text="Cancel" type="secondary" @click="cancelEvent"/>
              <btn text="Save" type="primary" @click="submitData"/>
            </btn-grp>
          </template>
        </popup-bottom-container>
      </footer>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: "ChapterVIAPopup",
   props: {
    section6a:{
      type:Object
    }
  },
  data() {
    return {
      showSuccessMsg: false,
      toast:false,
      errmsg:'',
      section6aUpdate:[],
      addfilelocation:[],
      model: {
        policy_number: "",
        policy_holder_name: "",
        relationship: "",
        sum_assured: "",
        policy_date: "",
        date_payment: "",
        premium_amount: 0,
        proofs:""
      },
      docUrl: "",
      policyList:[],
      tableColumns: [
        {
          label: "Sr. No.",
          key: "srNo"
        },
        {
          label: "Policy Number",
          key: "policy_number"
        },
        {
          label: "Policy Date",
          key: "policy_date"
        },
        {
          label: "Policy Holder Name",
          key: "policy_holder_name"
        },
        {
          label: "Sum Assured",
          key: "sum_assured"
        },
        {
          label: "Payment Date",
          key: "date_payment"
        },
        {
          label: "Premium Amount",
          key: "premium_amount"
        },
        {
          label: "Proofs",
          key: "proofs"
        }
      ],
    };
  },
  computed: {
    ...mapState("dashboard/organisation/utilities/itdeclarations", {
      trData: state => state.TR,
      irData: state => state.IR
    })
  },
   mounted() {
    this.showSuccessMsg = false;
    this.load();
    
  },
  activated() {
    this.showSuccessMsg = false;
    if (this.$route.query.page == "Internet Reimbursement") {
      this.tableColumns[5] = {
        label: "Account Number",
        key: "account_number"
      };
      this.setIRData();
    } else {
      this.tableColumns[5] = {
        label: "Mobile Number",
        key: "mobile_number"
      };
      this.setTRData();
    }
  },
  methods: {
    ...mapActions({
      saveTRData: "dashboard/organisation/utilities/itdeclarations/saveTR",
      saveIRData: "dashboard/organisation/utilities/itdeclarations/saveIR"
    }),
    back() {
      this.$router.go(-1);
    },
    setGolbalData() {
      try {
       
        this.stateList = this.globalData
          ? this.globalData.State
            ? this.globalData.State
            : []
          : [];
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
  
      load(){
        this.setGolbalData();
        //console.log("data check...............",this.section6a);
         this.section6aUpdate=this.section6a;
            if(this.section6a.details.length){
                this.policyList = this.section6a.details;
                this.addfilelocation = this.section6a.file_location
            }else{
              //console.log("no data in details");
            }
          
        
        

      },
     submitData(){
        //this.$router.push({
        //    path: `/dashboard/${this.$route.params.entity_index}/payroll/incometaxproofplan`,
        //  });
      
        this.section6aUpdate.details=this.policyList;
       
       //console.log("location array",this.addfilelocation);
        //this.section10Update.file_location=this.section10Update.details[0].proofs;
        //console.log("data check for updated",this.section6aUpdate);
        this.$emit("section6aPopupUpdate",this.section6aUpdate,this.addfilelocation);
    },
    async submit() {
      try {
        if (this.$route.query.page == "Internet Reimbursement") {
          await this.saveIRData({
            id: this.$route.query.id,
            data: this.policyList,
            proofs: this.policyList.map(item => {
              return item.proofs[0];
            })
          });
        } else {
          await this.saveTRData({
            id: this.$route.query.id,
            data: this.policyList,
            proofs: this.policyList.map(item => {
              return item.proofs[0];
            })
          });
        }
        this.showSuccessMsg = true;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    setIRData() {
      try {
        if (this.irData[this.$route.query.id]) {
          this.policyList = this.irData[this.$route.query.id].data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    setTRData() {
      try {
        if (this.trData[this.$route.query.id]) {
          this.policyList = this.trData[this.$route.query.id].data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

     addMore() {
      try {
        if(this.model.policy_number && this.model.policy_holder_name){
          this.policyList.push({
          policy_number: this.model.policy_number,
          policy_holder_name: this.model.policy_holder_name,
          relationship: this.model.relationship,
          sum_assured: this.model.sum_assured,
          policy_date: this.model.policy_date,
          premium_amount: this.model.premium_amount,
          proofs: [this.docUrl],
          index: this.policyList.length,
        });
        }
        if(this.docUrl){
          this.addfilelocation.push(this.docUrl)
        }
        this.resetForm();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    resetForm() {
      try {
        this.model = {
          policy_number: "",
          bill_date: "",
          month: "",
          service_provider: "",
          mobile_number: "",
          account_number: "",
          amount: 0,
          proof:"",
        };
        this.docUrl = "";
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
      deleteItem(record) {
      try {
        let index = this.policyList.findIndex(item => item.index == record.index);
        this.policyList.splice(index, 1);
        this.addfilelocation.splice(index,1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    cancelEvent() {
      this.$emit("hidemodal");
    }
    
  }
};
</script>

<style lang="scss" scoped>
.top-bar {
  height: auto;
  padding: 20px;
  background-color: #34c0be;
  display: flex;
}
.heading_new {
  width: auto;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}
.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}

.d_heading {
  font-size: 14px;
  font-weight: 600;
  opacity: 0.68;
  color: #646464;
}
.upload-heading {
  font-size: 13px;
  font-weight: 500;
}
</style>
